import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, AwardIcon, BadgeCheckIcon, FileTextIcon, FlameIcon, MapPinIcon, PhoneIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
import { CtaBand } from '../components/CtaBand';
import { company, decennale, domains, images, qualifications, services, zones } from '../data/site';
const proofPoints = [{
  icon: AwardIcon,
  title: 'Ramoneur-Fumiste diplômé',
  text: 'Diplômé du COSTIC — ramonage, débistrage, tubage et pose de poêle conformes à la réglementation.'
}, {
  icon: ShieldCheckIcon,
  title: 'Garantie décennale',
  text: 'Garantie décennale pour l’ensemble des prestations réalisées.'
}, {
  icon: MapPinIcon,
  title: 'Artisan local',
  text: 'Installé à Lostanges, intervention sur l’ensemble de la Corrèze.'
}, {
  icon: FileTextIcon,
  title: 'Devis sur demande',
  text: 'Un besoin, un conseil, un chiffrage : le devis est établi sur demande.'
}];
export function Home() {
  const [featured, ...others] = services;
  return <>
      {/* HERO */}
      <section className="bg-navy-800" data-id="element-204" data-mp="2vvvms7biyjc8">
        <div className="mx-auto max-w-content px-5 pb-14 pt-12 lg:px-8 lg:pb-20 lg:pt-20" data-id="element-205" data-mp="2qxu61t1kmw3x">
          <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-206" data-mp="2mxjodj4f2h98">
            <div className="lg:col-span-6" data-id="element-207" data-mp="2hxxar8koeyzw">
              <p className="inline-flex items-center gap-2 font-display text-sm font-bold uppercase tracking-[0.14em] text-ember-300" data-id="element-208" data-mp="2hyp8aoxu36st">
                <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-209" data-mp="2d5dx6blzo3v3" />
                Corrèze · Lostanges
              </p>
              <h1 className="mt-4 font-display text-[2.15rem] font-extrabold leading-[1.06] tracking-tight text-white sm:text-[3rem] lg:text-[3.4rem]" data-id="element-210" data-mp="239avt7yyo997">
                Chauffage, ramonage et plomberie,
                <span className="block text-ember-300" data-id="element-211" data-mp="1u8l68m0anf3x">par un artisan d'ici.</span>
              </h1>
              <p className="mt-5 max-w-xl text-[1.05rem] leading-relaxed text-navy-100 lg:text-lg" data-id="element-212" data-mp="1kkz3lhbvc1uf">
                {company.intro}
              </p>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-213" data-mp="1onnavkkxp0pa">
                <a href={company.phoneHref} className="inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-xl bg-ember-500 px-6 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-ember-600" data-id="element-214" data-mp="1ankww9fqyrfb">
                  <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-215" data-mp="2890546amqi0c" />
                  {company.phone}
                </a>
                <Link to="/contact" className="inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-xl border border-navy-400 px-6 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-navy-700" data-id="element-216" data-mp="1tjaznyvi7ru9">
                  Demander un devis
                  <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-217" data-mp="fl0rls6l8wux" />
                </Link>
              </div>

              <ul className="mt-8 flex flex-wrap gap-x-5 gap-y-2.5" data-id="element-218" data-mp="am7nurh3sk7y">
                {domains.map(d => <li key={d} className="flex items-center gap-2 text-[0.95rem] font-medium text-navy-100" data-id="element-219" data-mp="odcg38i56a89">
                    <BadgeCheckIcon className="h-4 w-4 shrink-0 text-ember-300" aria-hidden="true" data-id="element-220" data-mp="3stdkj0nvexf7" />
                    {d}
                  </li>)}
              </ul>
            </div>

            <div className="lg:col-span-6" data-id="element-221" data-mp="ot8ywatw3hr">
              <img src={images.hero} alt="Entretien d'un poêle à granulés dans une maison en pierre" className="aspect-[4/3] w-full rounded-2xl object-cover shadow-lift" data-id="element-222" data-mp="nrzgw9gnp25" />
            </div>
          </div>
        </div>
      </section>

      {/* PREUVES */}
      <section className="border-b border-line bg-white" aria-labelledby="garanties-titre" data-id="element-223" data-mp="27fprg3uahx5v">
        <h2 id="garanties-titre" className="sr-only" data-id="element-224" data-mp="2ceszzy9halil">
          Garanties et qualifications
        </h2>
        <div className="mx-auto grid max-w-content gap-x-8 gap-y-8 px-5 py-12 sm:grid-cols-2 lg:grid-cols-4 lg:px-8 lg:py-14" data-id="element-225" data-mp="2hefbo39nrtpa">
          {proofPoints.map(p => <div key={p.title} className="flex gap-4" data-id="element-226" data-mp="2qc7rr9n7f5dq">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy-50 text-navy-600" data-id="element-227" data-mp="2vbc0y0a4p342">
                <p.icon className="h-5 w-5" aria-hidden="true" data-id="element-228" data-mp="303loj9nrtr36" />
              </span>
              <div data-id="element-229" data-mp="351wwtfyf3tja">
                <h3 className="font-display text-[0.98rem] font-bold text-navy-800" data-id="element-230" data-mp="350c2nrg0mcly">
                  {p.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-navy-500" data-id="element-231" data-mp="39yneg7pvex6t">
                  {p.text}
                </p>
              </div>
            </div>)}
        </div>
      </section>

      {/* SERVICES */}
      <section className="bg-surface" aria-labelledby="services-titre" data-id="element-232" data-mp="ydmu038pt1ut">
        <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-233" data-mp="yfhghlzmx210">
          <SectionHeading eyebrow="Nos prestations" title="Un seul artisan pour tout votre confort thermique et sanitaire" text="Chauffage, ramonage, débistrage, climatisation, plomberie et ventilation : installation, entretien et dépannage." data-id="element-234" data-mp="tetp2z7huj69" />

          <div className="mt-10 grid gap-6 lg:mt-14 lg:grid-cols-12" data-id="element-235" data-mp="1h577rz46v5o6">
            {/* Carte mise en avant : la spécialité diplômée */}
            <article className="flex flex-col overflow-hidden rounded-2xl bg-white shadow-card lg:col-span-7" data-id="element-236" data-mp="1catats9voqhe">
              <img src={featured.image} alt={featured.imageAlt} className="h-56 w-full object-cover sm:h-72 lg:h-80" loading="lazy" data-id="element-237" data-mp="24tgq2r271bak" />
              <div className="flex flex-1 flex-col p-6 sm:p-8" data-id="element-238" data-mp="3ua2hwr28z5sw">
                <p className="font-display text-xs font-bold uppercase tracking-[0.16em] text-ember-500" data-id="element-239" data-mp="3ucoythb12xns">
                  Spécialité diplômée
                </p>
                <h3 className="mt-2 font-display text-2xl font-extrabold tracking-tight text-navy-800 sm:text-[1.75rem]" data-id="element-240" data-mp="3kjzr8xilm3xq">
                  {featured.label}
                </h3>
                <p className="mt-3 text-[1.02rem] leading-relaxed text-navy-500" data-id="element-241" data-mp="3ambw46h2yuf1">
                  {featured.summary}
                </p>
                <ul className="mt-5 space-y-2.5" data-id="element-242" data-mp="3fmzl6mlr116m">
                  {featured.bullets.slice(0, 3).map(b => <li key={b} className="flex gap-3 text-[0.95rem] leading-relaxed text-navy-600" data-id="element-243" data-mp="31nzyhkhsqwd3">
                      <BadgeCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ember-500" aria-hidden="true" data-id="element-244" data-mp="zvv9agromd62" />
                      {b}
                    </li>)}
                </ul>
                <Link to={featured.path} className="mt-auto inline-flex items-center gap-2 pt-7 font-display font-bold text-navy-700 transition-colors duration-150 ease-out hover:text-ember-500" data-id="element-245" data-mp="19z0in2kc08f2">
                  Voir le détail du ramonage
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-246" data-mp="1xnjshmj14t99" />
                </Link>
              </div>
            </article>

            <div className="grid gap-6 lg:col-span-5" data-id="element-247" data-mp="1so6x2de3edv2">
              {others.map(s => <article key={s.key} className="flex flex-1 flex-col rounded-2xl bg-white p-6 shadow-card sm:p-7" data-id="element-248" data-mp="26ngbp8mngzwx">
                  <h3 className="font-display text-xl font-extrabold tracking-tight text-navy-800" data-id="element-249" data-mp="ca6vyz3igi68">
                    {s.label}
                  </h3>
                  <p className="mt-3 text-[0.98rem] leading-relaxed text-navy-500" data-id="element-250" data-mp="8ay2zwgaoobq">
                    {s.summary}
                  </p>
                  <ul className="mt-4 space-y-2" data-id="element-251" data-mp="11swj4mze6l8k">
                    {s.bullets.slice(0, 3).map(b => <li key={b} className="flex gap-3 text-[0.92rem] leading-relaxed text-navy-600" data-id="element-252" data-mp="16jcxqaey8cwi">
                        <BadgeCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ember-500" aria-hidden="true" data-id="element-253" data-mp="dv7anh0fabti" />
                        {b}
                      </li>)}
                  </ul>
                  <Link to={s.path} className="mt-auto inline-flex items-center gap-2 pt-6 font-display font-bold text-navy-700 transition-colors duration-150 ease-out hover:text-ember-500" data-id="element-254" data-mp="mxzzzeq1odgp">
                    En savoir plus
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-255" data-mp="238at9uuiweuq" />
                  </Link>
                </article>)}
            </div>
          </div>
        </div>
      </section>

      {/* ARTISAN + QUALIFICATIONS */}
      <section className="bg-white" aria-labelledby="artisan-titre" data-id="element-256" data-mp="23o0twanycbhl">
        <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-257" data-mp="23lwil7nq4a7a">
          <div className="grid gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-258" data-mp="1zm5tr9hrc45e">
            <div className="lg:col-span-5" data-id="element-259" data-mp="1unukp0zadxo8">
              <div className="rounded-2xl bg-navy-800 p-7 sm:p-8" data-id="element-260" data-mp="1ulhuk0jdkh03">
                <p className="font-display text-xs font-bold uppercase tracking-[0.16em] text-ember-300" data-id="element-261" data-mp="1pnq47aydp2y0">
                  L'entreprise
                </p>
                <p className="mt-3 font-display text-2xl font-extrabold text-white" data-id="element-262" data-mp="1gntdl3sfhu0b">
                  Chauffe Plus 19
                </p>
                <p className="mt-1 text-[0.98rem] text-navy-100" data-id="element-263" data-mp="3f2ed327rg2ra">
                  {company.owner}, artisan installateur
                </p>

                <dl className="mt-7 divide-y divide-navy-700 border-t border-navy-700" data-id="element-264" data-mp="3azzy4t77pn5a">
                  <div className="py-4" data-id="element-265" data-mp="cqo8hysr4ozu">
                    <dt className="text-xs font-medium uppercase tracking-[0.12em] text-navy-300" data-id="element-266" data-mp="8nj75zkeqtcs">
                      Atelier
                    </dt>
                    <dd className="mt-1.5 text-[0.98rem] leading-relaxed text-white" data-id="element-267" data-mp="mkokmkmgaui2">
                      {company.addressLines.map(line => <span key={line} className="block" data-id="element-268" data-mp="3q2pz3cmfb3h7">
                          {line}
                        </span>)}
                    </dd>
                  </div>
                  <div className="py-4" data-id="element-269" data-mp="3of0bfkyh7pm">
                    <dt className="text-xs font-medium uppercase tracking-[0.12em] text-navy-300" data-id="element-270" data-mp="3p7wjmmageti">
                      Téléphone
                    </dt>
                    <dd className="mt-1.5" data-id="element-271" data-mp="37cgjn11mlf7k">
                      <a href={company.phoneHref} className="whitespace-nowrap font-display text-xl font-extrabold text-white transition-colors duration-150 ease-out hover:text-ember-300" data-id="element-272" data-mp="37b5k5df7qtm9">
                        {company.phone}
                      </a>
                    </dd>
                  </div>
                  <div className="py-4" data-id="element-273" data-mp="18w7qsgcr8gwp">
                    <dt className="text-xs font-medium uppercase tracking-[0.12em] text-navy-300" data-id="element-274" data-mp="18td6qpxnky3t">
                      E-mail
                    </dt>
                    <dd className="mt-1.5" data-id="element-275" data-mp="20nfbfdjq8iqi">
                      <a href={company.emailHref} className="break-all text-[0.98rem] font-medium text-white transition-colors duration-150 ease-out hover:text-ember-300" data-id="element-276" data-mp="20kjbjjobjjzf">
                        {company.email}
                      </a>
                    </dd>
                  </div>
                  <div className="py-4" data-id="element-277" data-mp="g5hatnfwra83">
                    <dt className="text-xs font-medium uppercase tracking-[0.12em] text-navy-300" data-id="element-278" data-mp="g8vgb4jvbzjr">
                      Devis
                    </dt>
                    <dd className="mt-1.5 text-[0.98rem] text-white" data-id="element-279" data-mp="2mtq1b6oij434">
                      Sur demande, sans engagement
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
            <div className="lg:col-span-7" data-id="element-280" data-mp="2d3ev1dhcwit2">
              <h2 id="artisan-titre" className="font-display text-[1.75rem] font-extrabold leading-tight tracking-tight text-navy-800 sm:text-4xl" data-id="element-281" data-mp="293mkiv8ek2l2">
                Julien Nésius, votre interlocuteur unique en Corrèze
              </h2>
              <p className="mt-5 text-[1.05rem] leading-relaxed text-navy-600" data-id="element-282" data-mp="1z7jidpdjw3y4">
                {company.about}
              </p>
              <p className="mt-4 text-[1.05rem] leading-relaxed text-navy-600" data-id="element-283" data-mp="1q5ac5bpbewqj">
                {company.ramoneurNote}
              </p>

              <h3 className="mt-10 font-display text-sm font-bold uppercase tracking-[0.16em] text-ember-500" data-id="element-284" data-mp="3ojlhdackkc60">
                Installateur diplômé
              </h3>
              <ul className="mt-5 divide-y divide-line border-y border-line" data-id="element-285" data-mp="16bk472gzrwym">
                {qualifications.map(q => <li key={q.title} className="flex gap-4 py-4" data-id="element-286" data-mp="1b8altu8g30m5">
                    <BadgeCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-400" aria-hidden="true" data-id="element-287" data-mp="1g0bruyf0rv3q" />
                    <div data-id="element-288" data-mp="nbwgclv3jux5">
                      <p className="font-display text-[1rem] font-bold text-navy-800" data-id="element-289" data-mp="ncobjvks7qmw">
                        {q.title}
                      </p>
                      {q.detail && <p className="mt-1 text-sm leading-relaxed text-navy-500" data-id="element-290" data-mp="wcuongckiolj">
                          {q.detail}
                        </p>}
                    </div>
                  </li>)}
              </ul>
              <p className="mt-5 inline-flex items-center gap-2.5 rounded-xl bg-navy-50 px-4 py-3 font-display text-[0.98rem] font-bold text-navy-700" data-id="element-291" data-mp="27rhxfudiel0e">
                <ShieldCheckIcon className="h-5 w-5 text-ember-500" aria-hidden="true" data-id="element-292" data-mp="2b95mjh75j358" />
                {decennale}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ZONES */}
      <section className="border-y border-line bg-surface" aria-labelledby="zones-titre" data-id="element-293" data-mp="2k80uaxpuglan">
        <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-20" data-id="element-294" data-mp="2gav0p5po7wxj">
          <div className="grid gap-10 lg:grid-cols-12 lg:items-center lg:gap-14" data-id="element-295" data-mp="2u6yr0nxfbl4q">
            <div className="lg:col-span-5" data-id="element-296" data-mp="2p8ezm8029h4z">
              <h2 id="zones-titre" className="font-display text-[1.75rem] font-extrabold leading-tight tracking-tight text-navy-800 sm:text-4xl" data-id="element-297" data-mp="2p7m27xmzs3zi">
                Une intervention de proximité, partout en Corrèze
              </h2>
              <p className="mt-4 text-[1.02rem] leading-relaxed text-navy-500" data-id="element-298" data-mp="3czaoaw97zw80">
                Basé à Lostanges, Chauffe Plus 19 se déplace sur l'ensemble du
                département.
              </p>
            </div>
            <ul className="grid gap-3 sm:grid-cols-2 lg:col-span-7" data-id="element-299" data-mp="3rjwwmaql2a83">
              {zones.map(z => <li key={z} className="flex items-center gap-3 rounded-xl bg-white px-4 py-3.5 font-display font-semibold text-navy-700 shadow-card" data-id="element-300" data-mp="3il1sd473na7f">
                  <MapPinIcon className="h-4 w-4 shrink-0 text-ember-500" aria-hidden="true" data-id="element-301" data-mp="38vi9vznatid3" />
                  {z}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      <CtaBand data-id="element-302" data-mp="2yuzi8iphsxkm" />
    </>;
}